import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M1.268 4.08h15.464m-6.15-2.812H7.418a1.054 1.054 0 0 0-1.054 1.054V4.08h5.272V2.322a1.055 1.055 0 0 0-1.054-1.054M7.418 13.042V7.77m3.164 5.272V7.77m3.24 7.992a1.05 1.05 0 0 1-1.047.97h-7.55a1.047 1.047 0 0 1-1.047-.97L3.201 4.08h11.598z"
    }, null, -1)
  ])))
}
export default { render: render }